export default __webpack_public_path__ + "4c352706bd6f08a40d10b54aaee15a0b.png";